export default __webpack_public_path__ + "static/media/secondCircle.886502ea.svg";